import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { NgxMatIntlTelInputModule } from 'ngx-mat-intl-tel-input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Screen1Component } from './landing-screen/screen1.component';
import { Screen2Component } from './screen2/screen2.component';
import { HttpClientModule } from '@angular/common/http';
import {MatDialogModule} from '@angular/material/dialog';
import { NotifyDialogComponent } from './notify-dialog/notify-dialog.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { BannerComponent } from './features/banner/banner.component';
import { Banner2Component } from './features/banner2/banner2.component';
import { Banner3Component } from './features/banner3/banner3.component';
import {MatIconModule} from '@angular/material/icon';
import {MatSelectModule} from '@angular/material/select';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ServicesSectionComponent } from './features/services-section/services-section.component';
import { ServicesSection2Component } from './features/services-section2/services-section2.component';
import { ServicesSection3Component } from './features/services-section3/services-section3.component';
import { AddressSectionComponent } from './features/address-section/address-section.component';
import { Home1Component } from './pages/home1/home1.component';
import { Home2Component } from './pages/home2/home2.component';
import { Home3Component } from './pages/home3/home3.component';
import { Home4Component } from './pages/home4/home4.component';
import { Home5Component } from './pages/home5/home5.component';
import { Home6Component } from './pages/home6/home6.component';
import { Home7Component } from './pages/home7/home7.component';
import { Home8Component } from './pages/home8/home8.component';
import { Home9Component } from './pages/home9/home9.component';
import { Home10Component } from './pages/home10/home10.component';
import { Home11Component } from './pages/home11/home11.component';
import { Home12Component } from './pages/home12/home12.component';
import { Home13Component } from './pages/home13/home13.component';
import { PricingComponent } from './pages/pricing/pricing.component';
import { ContactComponent } from './pages/contact/contact.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    BannerComponent,
    Banner2Component,
    Banner3Component,
    Screen1Component,
    Screen2Component,
    NotifyDialogComponent,
    ServicesSectionComponent,
    ServicesSection2Component,
    ServicesSection3Component,
    AddressSectionComponent,
    Home1Component,
    Home2Component,
    Home3Component,
    Home4Component,
    Home5Component,
    Home6Component,
    Home7Component,
    Home8Component,
    Home9Component,
    Home10Component,
    Home11Component,
    Home12Component,
    Home13Component,
    PricingComponent,
    ContactComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatInputModule,
    NgxMatIntlTelInputModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatDialogModule,
    MatIconModule,
    HttpClientModule,
    MatSelectModule
  ],
  providers: [
    {provide: LocationStrategy, useClass: HashLocationStrategy},
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
